import React, { useState, useEffect } from "react";
import { ImCross } from "react-icons/im";
import { IoMdArrowBack } from "react-icons/io";
import { useNavigate } from 'react-router-dom';

const SystemConfig = () => {
  const [logoName, setLogoName] = useState("");
  const [logoImage, setLogoImage] = useState(null);
  const [logoFile, setLogoFile] = useState(null);
  const [preview, setPreview] = useState("");
  const [uploadedLogos, setUploadedLogos] = useState([]);
  const [configOpen, setConfigOpen] = useState(false);
  const [ebvalue,setEbValue] = useState('')
   const navigate = useNavigate();

  const handleNameChange = (e) => {
    setLogoName(e.target.value);
  };

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreview(reader.result);
      };
      reader.readAsDataURL(file); // Convert image to base64
      setLogoFile(file);
    }
  };

  const handleUpload = () => {
    if (logoName && preview) {
      const newLogo = {
        name: logoName,
        image: preview,
      };

      localStorage.setItem("uploadedLogo", JSON.stringify(newLogo));
      setUploadedLogos([newLogo]);

      setLogoName("");
      setLogoFile(null);
      setPreview("");

      setUploadedLogos([]);
    }
  };
  return (
   <div className=" px-4 sm:px-6 md:px-10 mt-[10%]">
  
  <div className="relative flex items-center justify-center ">
    <button
      className="absolute left-4 text-black hover:text-red-600 text-xl"
      onClick={() => navigate(-1)}
    >
      <IoMdArrowBack fontSize={30} />
    </button>

    <h4 className="text-primary text-2xl font-bold uppercase">
      System Config
    </h4>
  </div>

 
  <div className="flex justify-center mt-5">
    <div className="w-full max-w-md bg-white rounded-2xl shadow-lg  p-4 sm:p-6">
      <div className="space-y-4">
        {/* Logo Name */}
        <div>
          <label className="block mb-1 font-medium text-sm text-gray-500">
            Logo Name
          </label>
         <input
  type="text"
  placeholder="Enter logo name"
  value={logoName}
  onChange={handleNameChange}
  className="w-full px-4 py-2 border border-gray-300 rounded-md text-sm 
             hover:border-primary focus:border-primary focus:outline-none 
             transition duration-200"
/>

        </div>

        {/* Upload Logo */}
        <div>
          <label className="block mb-1 font-medium text-sm text-gray-500">
            Upload Logo
          </label>
          <input
            type="file"
            accept="image/*"
            onChange={handleImageUpload}
            className="w-full px-4 py-2 border border-gray-300 rounded-md text-sm 
             hover:border-primary focus:border-primary focus:outline-none 
             transition duration-200"
          />
        </div>

        {/* EB Per Unit */}
        <div>
          <label className="block mb-1 font-medium text-sm text-gray-500">
            EB Per Unit
          </label>
          <input
            type="text"
            placeholder="Enter EB per unit value"
            value={ebvalue}
            onChange={setEbValue}
            className="w-full px-4 py-2 border border-gray-300 rounded-md text-sm 
             hover:border-primary focus:border-primary focus:outline-none 
             transition duration-200"
          />
        </div>

        {/* Upload Button */}
        <div className="pt-4">
          <button
            onClick={handleUpload}
            className="bg-primary font-semibold text-white px-4 py-2 rounded-md w-full text-sm"
          >
            Upload
          </button>
        </div>

        {/* Uploaded Logos List */}
        <div className="mt-6 space-y-4 max-h-60 overflow-y-auto scrollbar-thin scrollbar-thumb-gray-300 pr-1">
          {uploadedLogos.map((logo, index) => (
            <div
              key={index}
              className="flex gap-5 items-center border-b pb-2"
            >
              <div className="w-10 h-10">
                <img
                  src={logo.image}
                  alt={logo.name}
                  className="w-full h-full rounded-full object-cover"
                />
              </div>
              <h3 className="text-lg font-semibold">{logo.name}</h3>
            </div>
          ))}
        </div>
      </div>
    </div>
  </div>
</div>

 
  );
};

export default SystemConfig;
